<template>
  <div class="flex flex-row w-screen h-screen relative bg-gray-50">
    <BaseSidebar />
    <div class="h-full w-full flex flex-col flex-1 overflow-y-scroll">
      <div class="border-b w-full flex p-4 justify-between">
        <div class="flex gap-x-1">
          <span
            class="flex items-center cursor-pointer"
            @click="$router.push('/contacts')"
          >
            Contacts
          </span>

          <span
            v-if="contactData"
            class="flex items-center"
          >
            <Icon name="ic:baseline-keyboard-arrow-right" />
          </span>
          <span
            v-if="contactData"
            class="flex items-center text-primary-500 font-bold"
          >
            {{ contactData.firstName }} {{ contactData.lastName }}
          </span>
        </div>

        <div class="flex gap-2">
          <ContactAddToTargetList
            :contact="contactData"
            @refresh="loadContact"
          />

          <ContactSendEmail
            v-if="contactData?.email"
            :recipient="contactData?.email"
            :contactId="contactId"
          />

          <ContactSendSMS
            v-if="contactData?.phone"
            :recipient="contactData?.phone"
            :contactId="contactId"
          />

          <slot name="createNoteAndTaskButtons">
            <NoteCreate
              v-model:contact-id="contactId"
            />

            <TaskCreate
              v-model:contact-id="contactId"
            />
          </slot>
        </div>
      </div>
      <div
        v-if="!isLoading"
        class="flex flex-row w-full h-screen h-full"
      >
        <div class="h-full w-full flex-1 bg-gray-100 overflow-y-auto">
          <div
            class="max-h-full w-full grid grid-cols-9 gap-4 contentContainer overflow-y-auto"
          >
            <div
              class="col-span-6 rounded-xl shadow-sm border border-gray-100 overflow-hidden bg-white"
            >
              <Tabs
                v-model:value="activeTab"
                @update:value="handleTabChange($event)"
              >
                <TabList>
                  <Tab
                    v-for="tab in mainTabs"
                    :key="tab.value"
                    :value="tab.value"
                    class="flex items-center gap-2"
                  >
                    <Icon
                      :name="tab.iconify || ''"
                      class="text-lg"
                    />
                    {{ tab.name }}
                  </Tab>
                </TabList>
              </Tabs>

              <slot />
            </div>
            <div class="col-span-3">
              <ContactDetailPersonalInfo />
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="w-full flex items-center justify-center"
      >
        <ProgressSpinner />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useContacts } from '~/composables/useContacts'

const route = useRoute()
const isLoading = ref(true)
const contactId = computed(() => route.params.contactId as string)
const contactData = ref<any>(null)
const { fetchContactById } = useContacts()

onMounted(async () => {
  await loadContact()
})

watch(contactId, async () => {
  await loadContact()
})

const handleTabChange = (link: any) => {
  console.log(link)
  const getRoute = mainTabs.value.find(tab => tab.value === link)
  console.log(getRoute)
  navigateTo(getRoute?.route as string)
}

enum MainTabs {
  ACTIVITY = 'activity',
  LINKED_BUSINESSES = 'linked-businesses',
  OWNERSHIP = 'ownership',
  ADVANCED_PROFILE = 'advanced-profile',
}

console.log('route.name', route)

const mainTabs = ref([
  {
    iconify: 'material-symbols:analytics-outline',
    name: 'Activity',
    value: MainTabs.ACTIVITY,
    route: `/contacts/${contactId.value}/activity`,
    routeName: 'contacts-id-activity',
  },
  {
    iconify: 'hugeicons:building-01',
    name: 'Linked Businesses',
    value: MainTabs.LINKED_BUSINESSES,
    route: `/contacts/${contactId.value}/linked-businesses`,
    routeName: 'contacts-id-linked-businesses',
  },
  {
    iconify: 'material-symbols:groups-outline',
    name: 'Ownership',
    value: MainTabs.OWNERSHIP,
    route: `/contacts/${contactId.value}/ownership`,
    routeName: 'contacts-id-ownership',
  },
  {
    iconify: 'icomoon-free:profile',
    name: 'Advanced Profile',
    value: MainTabs.ADVANCED_PROFILE,
    route: `/contacts/${contactId.value}/advanced-profile`,
    routeName: 'contacts-id-advanced-profile',
  },
])

const activeTab = computed(() => {
  return mainTabs.value.find(tab => tab.routeName === route.name)?.value
})

const loadContact = async () => {
  if (!contactId.value) {
    isLoading.value = false
    return
  }

  isLoading.value = true
  try {
    const { data, error } = await fetchContactById(contactId.value)

    if (error || !data) {
      contactData.value = null
    }
    else {
      contactData.value = data
    }
  }
  catch (error) {
    console.error('Error loading contact:', error)
    contactData.value = null
  }
  finally {
    isLoading.value = false
  }
}
</script>
